<template>
	<div>
		<div class="match">
			<div class="wrapper">				
				<div class="match_row">
					<leagues v-if="leagues" :sport="sport" :data="leagues"></leagues>
					
					<div class="match_right">
						<match-header></match-header>
						
						<tab :headings="{results: 'Результаты', schedule: 'Расписание', standings: 'Таблица'}" active-key="results">
							<template v-slot:results>
								<links-result v-if="results" :data="results" :show-date="true"></links-result>
								<div v-else-if="resultsLoading" class="info-text"></div>
								<div v-else-if="!resultsLoading" class="info">Нет данных</div>
							</template>
							<template v-slot:schedule>
								<links-result :show-date="true" v-if="schedule" :data="schedule" :league-id="id"></links-result>
								<div v-else class="info">Нет данных</div>
							</template>
							<template v-slot:standings>
								<standings v-if="standings" :data="standings"></standings>
								<div v-else class="info">Нет данных</div>
							</template>
						</tab>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MatchHeader from "../../Common/MatchHeader";
	import Leagues from "../../Common/Leagues";
	import Tab from "../../../Tab/Tab";
	import Standings from "../Components/Events/Standings";
	import LinksResult from "../Components/Events/LinksResult";
	
	export default {
		components: {
			MatchHeader,
			Leagues,
			Tab,
			Standings,
			LinksResult,
		},
		
		data() {
			return {
				id: this.$route.params.id,
				leagues: null,
				sport: this.$route.params.sport,
				standings: null,
				results: null,
				resultsLoading: true,
				schedule: null,
			}
		},
		
		created() {
			this.initLeagues();
			
			this.initStandings();
			
			this.initResults();
			
			this.initSchedule();
		},
		
		
		methods: {
			initLeagues() {
				this.axios.get('/goalserve/' + this.sport + '/league')
					.then(({data}) => {
						this.leagues = data;
					});
			},
			initStandings() {
				this.axios.get('/goalserve/' + this.sport + '/league/standings?league_id=' + this.id)
					.then(({data}) => {
						this.standings = data.res ? data.res : null;
					});
			},
			initResults() {
				this.axios.get('/goalserve/' + this.sport + '/league/fixtures?status=finished&league_id=' + this.id)
					.then(({data}) => {
						this.results = data.res;
						
						if (this.results) {
							this.results[0].events = this.results[0].events.reverse();
						}
						this.resultsLoading = false;
					});
			},
			initSchedule() {
				this.axios.get('/goalserve/' + this.sport + '/league/fixtures?status=not_started&league_id=' + this.id)
					.then(({data}) => {
						this.schedule = data.res;
					});
			}
		}
	}
</script>